module.exports = __webpack_public_path__ + "img/voronoy-static-white.104bbbe.png";